(function ($) {
  'use strict';

  Drupal.behaviors.productQuantitySelectV1 = {
    attached: false,
    attach: function (context) {
      if (this.attached) {
        return;
      }
      this.attached = true;
      var $template = $('.js-product-qty-select', context);
      var $product = $template.closest('.js-product');
      var $addToBag = $('.js-add-to-cart', $product);
      var $productQuantityAmount = $('.js-product-qty-select-amount', $product);
      var $productQuantitySelect = $('.js-product-qty-select-type', $product);
      var $minusBtn = $template.find('button[data-plusminus="minus"]');
      var $plusBtn = $template.find('button[data-plusminus="plus"]');
      var maxQty = (Drupal.settings && Drupal.settings.max_qty) ? Drupal.settings.max_qty : 100;

      $addToBag.attr('data-qty', 1);
      $addToBag.data('qty', 1);

      $productQuantitySelect.each(function () {
        $(this).on('click', function (event) {
          var currQty = parseInt($addToBag.data('qty'), 10);
          var type = $(this).data('plusminus');

          $minusBtn.attr('disabled', false);
          $plusBtn.attr('disabled', false);
          if (type === 'plus') {
            currQty = (currQty < maxQty) ? currQty + 1 : currQty;
          } else {
            currQty = (currQty > 1) ? currQty - 1 : currQty;
          }
          if (currQty === maxQty) {
            $plusBtn.attr('disabled', true);
          }
          if (currQty === 1) {
            $minusBtn.attr('disabled', true);
          }
          $productQuantityAmount.text(currQty);
          $addToBag.attr('data-qty', currQty);
          $addToBag.data('qty', currQty);
          $product.trigger('product.qtySelect', [currQty]);
        });
      });
    }
  };
})(jQuery);
